import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, CardHeader } from 'reactstrap';
import BadgeThin from '../../components/Badges/BadgeThin';
import { ButtonLoading } from '../../components/Button';
import date from '../../helpers/date';
import { textOrDash } from './CustomerReviewCreate.helpers';
import {
  ACCOUNT_REMOVED_TEXT,
  APPROVE_DECISION,
  DECISION_PROGRESS_LABELS,
  NOT_YET_MODERATED_TEXT,
  REJECT_DECISION,
  STATUS_BADGE_COLORS,
  STATUS_LABELS,
} from './CustomerReviewDetail.helpers';
import styles from './CustomerReviewDetail.module.css';

const ModerationCard = ({ review, showActions, onDecide, submittingDecision }) => {
  const isModerated = Boolean(review.reviewed_at);
  const reviewedBy = review.reviewed_by;
  const isSubmitting = Boolean(submittingDecision);

  return (
    <Card>
      <CardHeader className={styles.cardHeader}>MODERATION</CardHeader>
      <CardBody className={styles.cardBody}>
        <div className={styles.kvRow}>
          <span className={styles.kvLabel}>Status</span>
          <span className={`${styles.kvValue} ${styles.kvValueBadge}`}>
            <BadgeThin
              className={styles.statusBadge}
              color={STATUS_BADGE_COLORS[review.status] || 'secondary'}
            >
              {textOrDash(STATUS_LABELS[review.status])}
            </BadgeThin>
          </span>
        </div>
        <div className={styles.kvRow}>
          <span className={styles.kvLabel}>Reviewed by</span>
          {isModerated ? (
            <span className={styles.kvValue}>
              {(reviewedBy && reviewedBy.username) || ACCOUNT_REMOVED_TEXT}
            </span>
          ) : (
            <span className={`${styles.kvValue} ${styles.kvMuted}`}>{NOT_YET_MODERATED_TEXT}</span>
          )}
        </div>
        <div className={styles.kvRow}>
          <span className={styles.kvLabel}>Reviewed at</span>
          {isModerated ? (
            <span className={styles.kvValue}>
              {date(review.reviewed_at).format('D MMM YYYY, HH:mm [WIB]')}
            </span>
          ) : (
            <span className={`${styles.kvValue} ${styles.kvMuted}`}>{NOT_YET_MODERATED_TEXT}</span>
          )}
        </div>
        {showActions && (
          <div className={styles.actions}>
            <ButtonLoading
              className={styles.actionButton}
              color="success"
              disabled={isSubmitting}
              isLoading={submittingDecision === APPROVE_DECISION}
              loadingMessage={DECISION_PROGRESS_LABELS[APPROVE_DECISION]}
              onClick={() => onDecide(APPROVE_DECISION)}
            >
              Approve
            </ButtonLoading>
            <ButtonLoading
              className={styles.actionButton}
              color="danger"
              disabled={isSubmitting}
              isLoading={submittingDecision === REJECT_DECISION}
              loadingMessage={DECISION_PROGRESS_LABELS[REJECT_DECISION]}
              onClick={() => onDecide(REJECT_DECISION)}
            >
              Reject
            </ButtonLoading>
          </div>
        )}
      </CardBody>
    </Card>
  );
};

ModerationCard.propTypes = {
  review: PropTypes.shape({
    status: PropTypes.string,
    reviewed_at: PropTypes.string,
    reviewed_by: PropTypes.object,
  }).isRequired,
  showActions: PropTypes.bool,
  onDecide: PropTypes.func.isRequired,
  submittingDecision: PropTypes.oneOf([APPROVE_DECISION, REJECT_DECISION]),
};

ModerationCard.defaultProps = {
  showActions: false,
  submittingDecision: null,
};

export default ModerationCard;
